import * as util from "util";
import { sanitize } from "./sanitize";

export function createStructuredLogJson(
  name: string,
  level: string,
  message: string,
  context?: Record<string, unknown>,
  error?: unknown,
): string {
  let errorDetails: unknown = undefined;
  if (error instanceof Error) {
    errorDetails = {
      name: error.name,
      message: error.message,
      stack: error.stack,
    };
  }
  const info = {
    name,
    level,
    message,
    context,
    error,
    errorDetails,
  };
  try {
    return JSON.stringify(sanitize(info));
  } catch (serialiseError) {
    return JSON.stringify({
      message: "serialisation error",
      data: util.inspect(sanitize({ ...info, serialiseError }), {
        depth: null,
      }),
    });
  }
}
